module.exports = require("@swa-ui/core/src/Toggle/Toggle.module.scss");